const STORAGE_KEY = 'orp_recently_viewed'
const productFetchCache = new Map()

const TRASH_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
  '<polyline points="3 6 5 6 21 6"></polyline>' +
  '<path d="M19 6l-1 14H6L5 6"></path>' +
  '<path d="M10 11v6M14 11v6"></path>' +
  '<path d="M9 6V4h6v2"></path>' +
  '</svg>'

function formatPrice(cents, currencyUnit = '$') {
  if (!Number.isFinite(Number(cents))) return ''
  return currencyUnit + (Number(cents) / 100).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

function productJsonUrl(handle) {
  let root = window.Shopify?.routes?.root || '/'
  if (root.charAt(root.length - 1) !== '/') root += '/'
  return root + 'products/' + encodeURIComponent(handle) + '.js'
}

function sizedImageUrl(url, width) {
  if (!url) return ''
  url = String(url).replace(/^https:(https:)/i, '$1')
  if (url.indexOf('//') === 0) url = 'https:' + url
  if (/_\d+x(\.[a-z0-9]+)(\?|$)/i.test(url)) {
    return url.replace(/_\d+x(\.[a-z0-9]+)(\?|$)/i, '_' + width + 'x$1$2')
  }
  return url.replace(/(\.[a-z0-9]+)(\?|$)/i, '_' + width + 'x$1$2')
}

function productImageUrl(product, width) {
  if (!product) return ''
  const img = product.featured_image || (product.images && product.images[0])
  let url = ''
  if (typeof img === 'string') url = img
  else if (img && typeof img === 'object') url = img.src || img.url || ''
  return sizedImageUrl(url, width || 600)
}

function variantImageUrl(variant, product, width) {
  const img = variant?.featured_image
  if (img && typeof img === 'object' && img.src) return sizedImageUrl(img.src, width || 600)
  if (typeof img === 'string' && img) return sizedImageUrl(img, width || 600)
  return productImageUrl(product, width)
}

function escapeHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

function hasOnlyDefaultVariant(product) {
  if (typeof product.has_only_default_variant === 'boolean') return product.has_only_default_variant
  const variants = product.variants || []
  if (variants.length !== 1) return false
  return (variants[0].title || '') === 'Default Title'
}

function productUrl(product) {
  if (product?.url) return product.url
  if (product?.handle) return '/products/' + encodeURIComponent(product.handle)
  return '#'
}

function optionsLabel(product) {
  const opts = product.options || []
  return opts
    .map((opt) => (typeof opt === 'string' ? opt : opt && opt.name))
    .filter(Boolean)
    .join(' | ')
}

function firstAvailableVariant(product) {
  if (product.variant_id && !(product.variants && product.variants.length)) {
    return {
      id: product.variant_id,
      available: product.available !== false,
      price: product.price,
      compare_at_price: product.compare_at_price || 0,
    }
  }
  const variants = product.variants || []
  return variants.find((v) => v.available) || variants[0] || null
}

function isRenderableSnapshot(entry) {
  return Boolean(entry && entry.handle && entry.id && entry.title && entry.variant_id)
}

function snapshotToProduct(entry) {
  return {
    id: entry.id,
    handle: entry.handle,
    url: entry.url,
    title: entry.title,
    vendor: entry.vendor || '',
    available: entry.available !== false,
    price: entry.price,
    compare_at_price: entry.compare_at_price,
    featured_image: entry.featured_image,
    variant_id: entry.variant_id,
    has_only_default_variant: entry.has_only_default_variant,
    variant_count: entry.variant_count,
    options: entry.options || [],
    variants: [
      {
        id: entry.variant_id,
        title: entry.has_only_default_variant ? 'Default Title' : '',
        available: entry.available !== false,
        price: entry.price,
        compare_at_price: entry.compare_at_price || 0,
      },
    ],
  }
}

function removeStoredProduct(productId) {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    let list = raw ? JSON.parse(raw) : []
    if (!Array.isArray(list)) list = []
    list = list.filter((item) => item && String(item.id) !== String(productId))
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list))
    document.dispatchEvent(new CustomEvent('orp:recently-viewed-updated'))
  } catch (e) { /* ignore */ }
}

function clearStoredHistory() {
  try {
    window.localStorage.setItem(STORAGE_KEY, '[]')
    document.dispatchEvent(new CustomEvent('orp:recently-viewed-updated'))
  } catch (e) { /* ignore */ }
}

function buildRemoveButton(productId, label) {
  const btn = document.createElement('button')
  btn.type = 'button'
  btn.className = 'rv-remove-badge'
  btn.setAttribute('aria-label', label || 'Remove from recently viewed')
  btn.innerHTML = TRASH_SVG
  btn.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation?.()
    removeStoredProduct(productId)
  })
  return btn
}

function buildCtbCard(product, source, labels, removeLabel, currencySymbol, eagerImage, isHero, showActions) {
  const variant = firstAvailableVariant(product)
  if (!variant) return null

  const soldOut = !variant.available
  const onlyDefault = hasOnlyDefaultVariant(product)
  const imageUrl = variantImageUrl(variant, product, isHero ? 900 : 600)
  const compareAt = variant.compare_at_price || 0
  const optionNames = optionsLabel(product)
  const href = productUrl(product)

  const card = document.createElement('div')
  card.className = 'orp-ctb__card' + (soldOut ? ' orp-ctb__card--sold-out' : '')
  card.dataset.orpCtbProductId = String(product.id)
  card.dataset.orpCtbHandle = product.handle || ''
  card.dataset.orpCtbVariantId = String(variant.id)
  card.dataset.orpCtbPrice = String(variant.price)
  card.dataset.orpCtbSoldOut = soldOut ? 'true' : 'false'
  card.dataset.orpCtbIncluded = 'false'
  card.dataset.orpCtbHasVariants = onlyDefault ? 'false' : 'true'
  card.dataset.orpCtbOptionsLabel = optionNames || 'Options'

  const body = document.createElement('div')
  body.className = 'orp-ctb__card-body'

  const imgLink = document.createElement('a')
  imgLink.className = 'orp-ctb__card-img-link'
  imgLink.href = href
  imgLink.tabIndex = -1

  if (source === 'trending' && labels.trending) {
    const statusBadge = document.createElement('span')
    statusBadge.className = 'rv-card-badge rv-card-badge--trending'
    statusBadge.textContent = labels.trending
    imgLink.appendChild(statusBadge)
  }

  if (soldOut) {
    const sold = document.createElement('span')
    sold.className = 'orp-ctb__badge orp-ctb__badge--sold-out'
    sold.textContent = 'Sold out'
    imgLink.appendChild(sold)
  }

  const img = document.createElement('img')
  img.className = 'orp-ctb__card-img'
  img.src = imageUrl
  img.alt = product.title || ''
  img.width = 400
  img.height = 400
  img.decoding = 'async'
  img.loading = eagerImage ? 'eager' : 'lazy'
  img.fetchPriority = 'low'
  img.dataset.orpCtbImage = ''
  imgLink.appendChild(img)

  if (source === 'viewed') imgLink.appendChild(buildRemoveButton(product.id, removeLabel))

  const details = document.createElement('div')
  details.className = 'orp-ctb__card-details'

  const name = document.createElement('a')
  name.className = 'orp-ctb__card-name'
  name.href = href
  name.textContent = product.title || ''

  const prices = document.createElement('div')
  prices.className = 'orp-ctb__card-prices'
  prices.dataset.orpCtbPriceDisplay = ''

  const compareEl = document.createElement('span')
  compareEl.className = 'orp-ctb__card-price-compare'
  compareEl.dataset.orpCtbComparePrice = ''
  if (compareAt > variant.price) {
    compareEl.textContent = formatPrice(compareAt, currencySymbol)
  } else {
    compareEl.hidden = true
  }

  const priceEl = document.createElement('span')
  priceEl.className = 'orp-ctb__card-price'
  priceEl.dataset.orpCtbCurrentPrice = ''
  priceEl.textContent = formatPrice(variant.price, currencySymbol)

  prices.appendChild(compareEl)
  prices.appendChild(priceEl)
  details.appendChild(name)
  details.appendChild(prices)

  if (showActions !== false) {
    const actionWrap = document.createElement('div')
    actionWrap.className = 'orp-ctb__variant-wrap'
    const actionBtn = document.createElement('button')
    actionBtn.type = 'button'
    actionBtn.className = 'orp-ctb__select-options-btn'
    actionBtn.dataset.rvCardAction = ''
    if (soldOut) {
      actionBtn.disabled = true
      actionBtn.textContent = 'Sold out'
    } else if (onlyDefault) {
      actionBtn.textContent = 'Add to cart'
    } else {
      actionBtn.textContent = 'Select options'
    }
    actionWrap.appendChild(actionBtn)
    details.appendChild(actionWrap)
  }

  body.appendChild(imgLink)
  body.appendChild(details)
  card.appendChild(body)
  return card
}

function wrapCtbSlide(card) {
  const slide = document.createElement('div')
  slide.className = 'swiper-slide orp-ctb__slide'
  slide.appendChild(card)
  return slide
}

function wrapBentoCell(card, cellRole) {
  const cell = document.createElement('div')
  let className = 'recently-viewed__bento-cell'
  if (cellRole === 'hero') className += ' recently-viewed__bento-cell--hero'
  else if (cellRole === 'last') className += ' recently-viewed__bento-cell--last'
  cell.className = className
  cell.appendChild(card)
  return cell
}

function markCardAdded(card) {
  card.classList.add('orp-ctb__card--included')
  const btn = card.querySelector('[data-rv-card-action]')
  if (!btn || btn.disabled) return
  const original = btn.dataset.rvIdleLabel || btn.textContent
  btn.dataset.rvIdleLabel = original
  btn.textContent = 'Added!'
  window.setTimeout(() => {
    if (btn.dataset.rvIdleLabel) btn.textContent = btn.dataset.rvIdleLabel
  }, 1200)
}

function updateCardFromOption(card, option, currencySymbol) {
  if (!option) return
  if (option.dataset.imageUrl) {
    const img = card.querySelector('[data-orp-ctb-image]')
    if (img) img.src = option.dataset.imageUrl
  }
  const priceEl = card.querySelector('[data-orp-ctb-current-price]')
  const compareEl = card.querySelector('[data-orp-ctb-compare-price]')
  const price = parseInt(option.dataset.price, 10) || 0
  const compare = parseInt(option.dataset.compareAtPrice, 10) || 0
  if (priceEl) priceEl.textContent = formatPrice(price, currencySymbol)
  if (compareEl) {
    if (compare > price) {
      compareEl.textContent = formatPrice(compare, currencySymbol)
      compareEl.hidden = false
    } else {
      compareEl.textContent = ''
      compareEl.hidden = true
    }
  }
  card.dataset.orpCtbVariantId = option.value
  card.dataset.orpCtbPrice = option.dataset.price
}

function fillSelectFromProduct(select, product, selectedId) {
  select.replaceChildren()
    ; (product.variants || []).forEach((v) => {
      const opt = document.createElement('option')
      opt.value = String(v.id)
      opt.dataset.price = String(v.price)
      opt.dataset.compareAtPrice = String(v.compare_at_price || 0)
      opt.dataset.available = v.available ? 'true' : 'false'
      const vImg = variantImageUrl(v, product, 600)
      if (vImg) opt.dataset.imageUrl = vImg
      if (String(v.id) === String(selectedId)) opt.selected = true
      if (!v.available) opt.disabled = true
      opt.textContent = v.title + (v.available ? '' : ' — Sold out')
      select.appendChild(opt)
    })
}

async function addVariantToCart(variantId, qty) {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: String(variantId), quantity: qty }] }),
  })
  if (!response.ok) throw new Error('Could not add this product to cart.')
  document.dispatchEvent(new CustomEvent('nova:cart:refresh', { bubbles: true, composed: true }))
  document.dispatchEvent(new CustomEvent('nova:cart:open', { bubbles: true }))
}

function whenIdle(fn) {
  if (typeof window.requestIdleCallback === 'function') {
    return window.requestIdleCallback(() => fn(), { timeout: 400 })
  }
  return window.setTimeout(fn, 1)
}

class RecentlyViewedRecommendations extends HTMLElement {
  connectedCallback() {
    this.container = this.querySelector('[data-rv-container]')
    this.track = this.querySelector('[data-rv-track]')
    this.swiperEl = this.querySelector('[data-rv-swiper]')
    this.bento = this.querySelector('[data-rv-bento]')
    this.layout = this.dataset.layout === 'carousel' ? 'strip' : (this.dataset.layout || 'strip')
    this.limit = parseInt(this.dataset.limit, 10) || 8
    this.currentProductId = String(this.dataset.currentProductId || '')
    this.currencySymbol = this.dataset.currencySymbol || '$'
    this.labels = {
      trending: this.dataset.trendingBadge || 'Trending',
    }
    this.removeLabel = this.getAttribute('data-remove-badge')
    if (this.removeLabel == null) this.removeLabel = 'Remove'
    this.showCardActions = this.dataset.showActions !== 'false'
    this.sectionEl = this.closest('.shopify-section')

    this._onUpdated = () => this.render()
    this._onPageShow = (e) => {
      if (e.persisted && this._paintedSignature === this.storageSignature()) return
      this.render()
    }
    this._onKeydown = (e) => {
      const overlay = this.querySelector('[data-rv-variant-modal-overlay]')
      if (e.key === 'Escape' && overlay?.classList.contains('active')) this.closeModal()
    }

    document.addEventListener('orp:recently-viewed-updated', this._onUpdated)
    window.addEventListener('pageshow', this._onPageShow)

    this.bindModal()
    this.bindClearHistory()
    this.querySelectorAll('[data-rv-card-action]').forEach((btn) => {
      this.bindCard(btn.closest('.orp-ctb__card'))
    })
    this.scheduleRender()
  }

  disconnectedCallback() {
    this.destroySwiper()
    if (this._onUpdated) document.removeEventListener('orp:recently-viewed-updated', this._onUpdated)
    if (this._onPageShow) window.removeEventListener('pageshow', this._onPageShow)
    if (this._onKeydown) document.removeEventListener('keydown', this._onKeydown)
  }

  scheduleRender() {
    if (this.isDesignMode()) {
      this.render()
      return
    }
    whenIdle(() => this.render())
  }

  bindClearHistory() {
    const btn = this.querySelector('[data-rv-clear]')
    if (!btn) return
    btn.addEventListener('click', (e) => {
      e.preventDefault()
      clearStoredHistory()
    })
  }

  setSectionVisible(visible) {
    if (this.sectionEl) this.sectionEl.hidden = !visible
    if (this.container) this.container.hidden = !visible
  }

  isDesignMode() {
    return Boolean(window.Shopify?.designMode)
  }

  storageSignature() {
    return this.getStoredEntries()
      .slice(0, this.limit)
      .map((item) => String(item.id))
      .join(',')
  }

  destroySwiper() {
    if (this._swiper) {
      try { this._swiper.destroy(true, true) } catch (e) { /* ignore */ }
      this._swiper = null
    }
  }

  initSwiper() {
    if (this.layout === 'spotlight' || !this.swiperEl) return
    const self = this

    const start = () => {
      const SwiperCtor = window.Swiper
      if (!SwiperCtor) {
        self._swiperWait = (self._swiperWait || 0) + 1
        if (self._swiperWait < 40) setTimeout(start, 50)
        return
      }

      self.destroySwiper()
      self._swiperWait = 0

      const prevEl = self.querySelector('[data-rv-prev]')
      const nextEl = self.querySelector('[data-rv-next]')

      self._swiper = new SwiperCtor(self.swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 14,
        freeMode: false,
        grabCursor: true,
        watchOverflow: true,
        centerInsufficientSlides: true,
        touchMoveStopPropagation: true,
        keyboard: { enabled: false },
        mousewheel: false,
        navigation: prevEl && nextEl ? { nextEl, prevEl } : undefined,
      })

      requestAnimationFrame(() => {
        try { self._swiper.update() } catch (e) { /* ignore */ }
      })
    }

    start()
  }

  getStoredEntries() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY)
      const list = raw ? JSON.parse(raw) : []
      if (!Array.isArray(list)) return []
      return list.filter((item) => Boolean(item && item.handle && item.id))
    } catch (e) {
      return []
    }
  }

  fetchProduct(handle) {
    if (!handle) return Promise.resolve(null)
    if (productFetchCache.has(handle)) return productFetchCache.get(handle)
    const request = fetch(productJsonUrl(handle))
      .then((res) => (res.ok ? res.json() : null))
      .catch(() => null)
    productFetchCache.set(handle, request)
    return request
  }

  getTrendingProducts() {
    if (this._trending) return this._trending
    const script = this.querySelector('[data-rv-trending]')
    if (!script) {
      this._trending = []
      return this._trending
    }
    try {
      const list = JSON.parse((script.textContent || '').trim() || '[]')
      this._trending = Array.isArray(list) ? list.map(snapshotToProduct) : []
    } catch (e) {
      this._trending = []
    }
    return this._trending
  }

  bindCard(card) {
    if (!card || card.dataset.orpCtbSoldOut === 'true') return
    const hasVariants = card.dataset.orpCtbHasVariants === 'true'
    const actionBtn = card.querySelector('[data-rv-card-action]')
    if (!actionBtn) return

    actionBtn.addEventListener('click', async (e) => {
      e.preventDefault()
      if (hasVariants) {
        this.openModal(card)
        return
      }
      const variantId = card.dataset.orpCtbVariantId
      if (!variantId) return
      actionBtn.disabled = true
      try {
        await addVariantToCart(variantId, 1)
        markCardAdded(card)
      } catch (err) {
        window.alert(err?.message || 'Could not add this product to cart.')
      } finally {
        actionBtn.disabled = false
      }
    })
  }

  bindModal() {
    const overlay = this.querySelector('[data-rv-variant-modal-overlay]')
    if (!overlay || overlay.dataset.rvBound) return
    overlay.dataset.rvBound = 'true'

    const close = () => this.closeModal()
    overlay.querySelector('[data-rv-variant-modal-close]')?.addEventListener('click', close)
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close()
    })
    document.addEventListener('keydown', this._onKeydown)

    const modalSelect = overlay.querySelector('[data-rv-variant-modal-select]')
    modalSelect?.addEventListener('change', () => this.syncModalFromSelect())

    overlay.querySelector('[data-rv-modal-qty-dec]')?.addEventListener('click', () => {
      const input = overlay.querySelector('[data-rv-modal-qty-input]')
      const n = Math.max(1, (parseInt(input.value, 10) || 1) - 1)
      input.value = String(n)
    })
    overlay.querySelector('[data-rv-modal-qty-inc]')?.addEventListener('click', () => {
      const input = overlay.querySelector('[data-rv-modal-qty-input]')
      const n = Math.min(99, (parseInt(input.value, 10) || 1) + 1)
      input.value = String(n)
    })

    overlay.querySelector('[data-rv-variant-modal-add]')?.addEventListener('click', async () => {
      const option = modalSelect?.options[modalSelect.selectedIndex]
      if (!option || option.dataset.available === 'false') return
      const qtyInput = overlay.querySelector('[data-rv-modal-qty-input]')
      const qty = Math.max(1, Math.min(99, parseInt(qtyInput.value, 10) || 1))
      const btn = overlay.querySelector('[data-rv-variant-modal-add]')
      const original = btn.textContent
      btn.disabled = true
      btn.textContent = 'Adding…'
      try {
        await addVariantToCart(option.value, qty)
        const card = overlay._rvCard
        if (card) {
          updateCardFromOption(card, option, this.currencySymbol)
          markCardAdded(card)
        }
        btn.textContent = 'Added!'
        setTimeout(() => {
          btn.textContent = original
          btn.disabled = false
          this.closeModal()
        }, 700)
      } catch (err) {
        btn.textContent = original
        btn.disabled = false
        window.alert(err?.message || 'Could not add this product to cart.')
      }
    })
  }

  async openModal(card) {
    const overlay = this.querySelector('[data-rv-variant-modal-overlay]')
    const modalSelect = overlay?.querySelector('[data-rv-variant-modal-select]')
    const handle = card.dataset.orpCtbHandle
    if (!overlay || !modalSelect || !handle) return

    const actionBtn = card.querySelector('[data-rv-card-action]')
    const original = actionBtn?.textContent
    if (actionBtn) {
      actionBtn.disabled = true
      actionBtn.textContent = 'Loading…'
    }

    const product = await this.fetchProduct(handle)
    if (actionBtn) {
      actionBtn.disabled = false
      actionBtn.textContent = original
    }
    if (!product) {
      window.alert('Could not load product options.')
      return
    }

    overlay._rvCard = card
    overlay.querySelector('[data-rv-variant-modal-title]').textContent =
      card.querySelector('.orp-ctb__card-name')?.textContent.trim() || product.title || ''
    overlay.querySelector('[data-rv-variant-modal-label]').textContent =
      card.dataset.orpCtbOptionsLabel || optionsLabel(product) || 'Options'

    fillSelectFromProduct(modalSelect, product, card.dataset.orpCtbVariantId)
    overlay.querySelector('[data-rv-modal-qty-input]').value = '1'
    this.syncModalFromSelect()

    overlay.classList.add('active')
    overlay.setAttribute('aria-hidden', 'false')
  }

  syncModalFromSelect() {
    const overlay = this.querySelector('[data-rv-variant-modal-overlay]')
    const modalSelect = overlay?.querySelector('[data-rv-variant-modal-select]')
    const option = modalSelect?.options[modalSelect.selectedIndex]
    if (!overlay || !option) return

    const img = overlay.querySelector('[data-rv-variant-modal-image]')
    const priceEl = overlay.querySelector('[data-rv-variant-modal-price]')
    const compareEl = overlay.querySelector('[data-rv-variant-modal-compare]')
    const addBtn = overlay.querySelector('[data-rv-variant-modal-add]')
    const price = parseInt(option.dataset.price, 10) || 0
    const compare = parseInt(option.dataset.compareAtPrice, 10) || 0

    if (img && option.dataset.imageUrl) img.src = option.dataset.imageUrl
    if (priceEl) priceEl.textContent = formatPrice(price, this.currencySymbol)
    if (compareEl) {
      if (compare > price) {
        compareEl.textContent = formatPrice(compare, this.currencySymbol)
        compareEl.hidden = false
      } else {
        compareEl.hidden = true
      }
    }
    if (addBtn) addBtn.disabled = option.dataset.available === 'false'
  }

  closeModal() {
    const overlay = this.querySelector('[data-rv-variant-modal-overlay]')
    if (!overlay) return
    overlay.classList.remove('active')
    overlay.setAttribute('aria-hidden', 'true')
    overlay._rvCard = null
  }

  async render() {
    const token = (this._renderToken = (this._renderToken || 0) + 1)
    const entries = this.getStoredEntries().slice(0, this.limit)

    const viewedItems = []
    const missing = []
    entries.forEach((entry) => {
      if (isRenderableSnapshot(entry)) {
        viewedItems.push({ product: snapshotToProduct(entry), viewedAt: entry.viewedAt, source: 'viewed' })
      } else {
        missing.push(entry)
      }
    })

    if (missing.length) {
      const fetched = await Promise.all(
        missing.map(async (entry) => {
          const product = await this.fetchProduct(entry.handle)
          return product ? { product, viewedAt: entry.viewedAt, source: 'viewed' } : null
        }),
      )
      if (token !== this._renderToken) return
      fetched.filter(Boolean).forEach((item) => viewedItems.push(item))
    }

    viewedItems.sort((a, b) => (b.viewedAt || 0) - (a.viewedAt || 0))

    if (viewedItems.length === 0 && !this.isDesignMode()) {
      this.destroySwiper()
      this.setSectionVisible(false)
      this._paintedSignature = this.storageSignature()
      return
    }

    let displayItems = viewedItems.slice(0, this.limit)
    const remaining = this.limit - displayItems.length
    if (remaining > 0 && (viewedItems.length > 0 || this.isDesignMode())) {
      const viewedIds = new Set(displayItems.map((item) => String(item.product.id)))
      this.getTrendingProducts()
        .filter((product) => {
          if (!product?.handle || !product.variant_id) return false
          if (viewedIds.has(String(product.id))) return false
          if (this.currentProductId && this.currentProductId !== '0' && String(product.id) === this.currentProductId) {
            return false
          }
          return true
        })
        .slice(0, remaining)
        .forEach((product) => displayItems.push({ product, source: 'trending' }))
    }

    if (token !== this._renderToken) return

    if (displayItems.length === 0) {
      this.destroySwiper()
      this.setSectionVisible(this.isDesignMode())
      this._paintedSignature = this.storageSignature()
      return
    }

    this.destroySwiper()
    if (this.track) this.track.replaceChildren()
    if (this.bento) this.bento.replaceChildren()

    if (this.layout === 'spotlight' && this.bento) {
      const heroItem = displayItems.find((item) => item.source === 'viewed') || displayItems[0]
      const ordered = [heroItem].concat(displayItems.filter((item) => item !== heroItem))
      const lastItem = ordered.length > 1 ? ordered[ordered.length - 1] : null
      const frag = document.createDocumentFragment()
      ordered.forEach((item, index) => {
        const isHero = item === heroItem
        const isLast = item === lastItem
        let cellRole = null
        if (isHero) cellRole = 'hero'
        else if (isLast) cellRole = 'last'
        const card = buildCtbCard(
          item.product,
          item.source,
          this.labels,
          this.removeLabel,
          this.currencySymbol,
          index < 2,
          isHero || isLast,
          this.showCardActions,
        )
        if (!card) return
        this.bindCard(card)
        frag.appendChild(wrapBentoCell(card, cellRole))
      })
      this.bento.appendChild(frag)
      this.bento.hidden = false
    } else if (this.track) {
      const frag = document.createDocumentFragment()
      displayItems.forEach((item, index) => {
        const card = buildCtbCard(
          item.product,
          item.source,
          this.labels,
          this.removeLabel,
          this.currencySymbol,
          index < 2,
          false,
          this.showCardActions,
        )
        if (!card) return
        this.bindCard(card)
        frag.appendChild(wrapCtbSlide(card))
      })
      this.track.appendChild(frag)
    }

    this.setSectionVisible(true)
    this._paintedSignature = this.storageSignature()
    this.initSwiper()
  }
}

if (!customElements.get('recently-viewed-recommendations')) {
  customElements.define('recently-viewed-recommendations', RecentlyViewedRecommendations)
}
